// taken from https://webostv.developer.lge.com/develop/code-samples/multi-sound/
let hidden, visibilityChange;

if (typeof document.hidden !== 'undefined') {   // To support the standard web browser engine
	hidden = 'hidden';
	visibilityChange = 'visibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {   // To support the webkit engine
	hidden = 'webkitHidden';
	visibilityChange = 'webkitvisibilitychange';
}

export default function isWebOsAppSuspended() {
	return document[hidden] && navigator.userAgent.match(/webos/i);
}

export function addSuspendEvents(source) {
	function handleVisibilityChange() {
		if (isWebOsAppSuspended()) {
			log('Tab hidden');
			source.stopAll();
		} else {
			log('Tab visible');
		}
	}

	document.addEventListener(visibilityChange, handleVisibilityChange, false);
}
